<template>
  <select
    class="dropdown"
    @change="$store.commit('setFilterValue', $event.target.value)"
  >
    <option
      value=""
    >
      {{ $config.common.search.pick }}
    </option>
    <option
      v-for="val in filterValues"
      :key="val.value"
      :value="val.value"
      :selected="filterValue === val.value"
    >
      {{ processPluralString(val.shortlabel, val.count) }}
    </option>
  </select>
</template>

<script>
import mixin from '@/components/common/filter/FilterMixin.vue';

export default {
  name: 'FilterValueMenu',
  mixins: [mixin],
  data() {
    return {
    };
  },
};
</script>

<style lang="stylus" scoped>
.dropdown {
  background-color: $cl-yellow;
  border: none;
  border-left: 2px $cl-dark-blue solid;;
  border-radius: 0;
  width: max-content;
  height: 50px;
  padding: 10px 40px 10px 30px
  display: flex;
  align-items: center;

  +mobile() {
    border-left: none;
    border-top: 2px $cl-dark-blue solid;
    width: 100%
  }
}

</style>
